import * as moment from 'moment';
import { Fragment, useState } from 'react';
import { IPosition } from '@nkr/models/index';
import { TableWrapper } from '../styles';
import PositionRow from './row';
import UpdateRow from './update-row';
import { InternalDirectAction } from '../../../models';

interface IProps {
    list: IPosition[],
    onSubmit: (id: number, donationDate: string, action: InternalDirectAction) => void
}

const OutstandingInternalDirectSwaps = (props: IProps) => {
    const [donorId, setDonorId] = useState(-1);
    const [clusterId, setClusterId] = useState(0);
    const [action, setAction] = useState(InternalDirectAction.Nothing);
    const [donationDate, setDonationDate] = useState('');

    const handleAction = (position: IPosition, action: InternalDirectAction) => {
        setDonorId(position.donor.id);
        setClusterId(position.clusterId);
        setAction(action);
        setDonationDate(moment(position.donor.logistics.kidneyPickupDateTime, 'MM/DD/YYYY').format('YYYY-MM-DD'));
    };

    const handleDonationDateChange = (donationDate: string) => {
        setDonationDate(donationDate);
    };

    const handleSubmit = () => {
        if (action == InternalDirectAction.ChangeDonationDate) {
            props.onSubmit(donorId, donationDate, action);
        } else {
            props.onSubmit(clusterId, donationDate, action);
        }
    };

    const handleCancel = () => {
        setDonorId(-1);
        setClusterId(0);
        setAction(InternalDirectAction.Nothing);
        setDonationDate('');
    };

    return (
        <>
            <TableWrapper className='table table-condensed table-striped table-bordered'>
                <thead>
                    <tr>
                        <th rowSpan={2}>Swap #</th>
                        <th colSpan={2}>Donor</th>
                        <th colSpan={2}>Recipient</th>
                        <th rowSpan={2}>Current<br />Donation Date</th>
                        <th rowSpan={2} style={{ width: 183 }}></th>
                    </tr>
                    <tr>
                        <th>Alias</th>
                        <th>Center</th>
                        <th>Alias</th>
                        <th>Center</th>
                    </tr>
                </thead>
                <tbody>
                    {props.list.map((item, index) =>
                        <Fragment key={'r-' + index}>
                            <PositionRow
                                data={item}
                                action={action}
                                onAction={handleAction}
                            />

                            {donorId == item.donor.id && (
                                <UpdateRow
                                    action={action}
                                    donationDate={donationDate}
                                    onChangeDonationDate={handleDonationDateChange}
                                    onSubmit={handleSubmit}
                                    onCancel={handleCancel}
                                />
                            )}
                        </Fragment>
                    )}
                </tbody>
            </TableWrapper>
        </>
    );
}

export default OutstandingInternalDirectSwaps;